import { tss } from 'tss-react/mui';

const useStyles = tss.create(() => ({
  paper: {
    width: '216mm',
    height: '279mm',
    boxSizing: 'border-box',
    margin: 0,
    padding: 0,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white', // for cover page
    position: 'relative' // ensure layering works if needed
  },
  addPageBreak: {
    pageBreakAfter: 'always'
  },
  reportPage: {
    backgroundColor: 'white',
    backgroundImage: 'url(/images/watermark.png)', // optional
    backgroundSize: 'cover',
    color: 'black',
    justifyContent: 'start',
    alignItems: 'center'
  },
  content: {
    width: '100%',
    paddingLeft: '10mm',
    paddingRight: '10mm',
    zIndex: 2
  },
  coverContent: {
    width: '100%',
    height: '100%',
    zIndex: 2
  },
  headerWrapper: {
    height: '100px',
    width: '100%',
    position: 'relative',
    background: 'linear-gradient(to bottom, #0a424d, #0A2648)',
    color: '#fff',
    overflow: 'hidden'
  },
  headerImage: {
    position: 'absolute',
    top: 30,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    pointerEvents: 'none',
    zIndex: 1,
    opacity: 0.4,
    filter: 'grayscale(1) brightness(1)'
  },
  headerContent: {
    position: 'relative',
    zIndex: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0 8mm 0 10mm',
    height: '100%'
  },
  headerTitle: {
    fontWeight: 'bold',
    color: '#D1E2D5',
    lineHeight: '1.5rem'
  },
  headerSubText: {
    lineHeight: '1.15rem',
    fontWeight: 400
  },
  sectionBar: {
    paddingRight: '10mm',
    marginBottom: '20px',
    backgroundColor: '#D1E2D5',
    width: '100%',
    textAlign: 'right',
    height: '30px'
  },
  sectionLabel: {
    color: '#22493C',
    textTransform: 'uppercase',
    fontWeight: 800,
    lineHeight: '30px',
    fontSize: '1.25rem'
  },
  logo: {
    height: '50px',
    marginRight: '10mm'
  },
  footerImageWrapper: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    width: '101%',
    zIndex: 0,
    pointerEvents: 'none'
  },
  footerImage: {
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
    display: 'block'
  },
  pageNumber: {
    position: 'absolute',
    textAlign: 'center',
    bottom: '1.4mm', // adjust this to match the vertical position on the green tab
    right: '20.4mm', // adjust this to align over the tab horizontally
    width: '14mm', // fixed width, so 1/2 goes left, 1/2 goes right of center
    zIndex: 3,
    pointerEvents: 'none'
  },
  pageNumberText: {
    fontWeight: 'bold',
    color: 'white',
    fontSize: '1.125rem'
  }
}));

export default useStyles;
